module.exports = __webpack_public_path__ + "img/tune_black_24dp.1713914f.svg";